<div mat-dialog-title class="markdown-title">
  <h4><strong>Switch through us to get our rewards</strong></h4>
</div>
<mat-dialog-content aria-label="FindOut more Dialog Content">
  <div class="modal-body">
    <div class="">
      <div class="fs-17 mb-2">Switch supplier through Compare the Market and enjoy our fantastic <a
          href="https://www.comparethemarket.com/information/rewards-terms/" target="_blank">rewards</a>.*</div>
      <div class="text-center mb-4">
        <img class="w-50" src="../../../../assets/ctm-images/ctmRewards.png" alt="Rewards" />
      </div>
      <div class="fs-17 mb-2">
        <div class="mb-3">
          When you’re ready to switch to a qualifying tariff, select the ‘Switch now’ button and complete the
          form to get our rewards.
        </div>
        <div class="mb-2 fw700">Tariffs we can’t switch you to</div>

        <div class="mb-3">
          If you choose a tariff we can’t help you switch to or you switch directly with the supplier, you
          won’t qualify for our rewards.
        </div>
      </div>

    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="reduceTopMargin" align="end" aria-label="Find More Dialog Actions"
  class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button class="btn btn-primary order-1 order-sm-2" (click)="cancel()">Close</button>
</mat-dialog-actions>